//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { i18n } from '@/i18n';
import HomeChart from '@/modules/home/components/home-chart.vue';
import { mapActions, mapGetters } from 'vuex';
// import * as firebase from 'firebase';
import firebase from 'firebase/app'
import 'firebase/firestore';
// import { i18n } from '@/i18n';

export default {
  name: 'app-home-header',
  components: {
    [HomeChart.name]: HomeChart,
  },

  // created() {
  //   if (this.isMobile) {
  //     this.collapseMenu();
  //   }
  // },

  data() {
    return {
      wid:0 ,
      hide:'visible' ,
      filter:'',
       pagination: {
            sortBy: 'desc',
            descending: false,
            page: 1,
            rowsPerPage: 30,
      },
      cachedData:'',
      cachedRows:[],
      globalCached:{},
      columns: [
        {
          name: 'Location',
          required: true,
          label: 'Location',
          align: 'center',
          field: 'country',
        },
        {
          name: 'New Confirmed',
          align: 'center',
          label: 'New Confirmed',
          field: 'newConfirmed',
        },
        {
          name: 'Total Confirmed',
          align: 'center',
          label: 'Total Confirmed',
          field: 'totalConfirmed',
        },
        {
          name: 'New Recovered',
          align: 'center',
          label: 'New Recovered',
          field: 'newRecovered',
        },
        {
          name: 'Total Recovered',
          align: 'center',
          label: 'Total Recovered',
          field: 'totalRecovered',
        },
        {
          name: 'New Deaths',
          align: 'center',
          label: 'New Deaths',
          field: 'newDeaths',
        },
        {
          name: 'Total Deaths',
          align: 'center',
          label: 'Total Deaths',
          field: 'totalDeaths',
        },
      ],
      
    
    global:{}
    };
  },

  computed: {
    ...mapGetters({
      isMobile: 'layout/isMobile',
      rows: 'home/list/rows',
      count: 'home/list/count',
      loading: 'home/list/loading',
      // pagination: 'home/list/pagination',
    }),
    pagesNumber () {
      // return Math.ceil(this.rows.length / this.pagination.rowsPerPage)
      if(this.cachedRows.length == 0) return 0
      return Math.ceil(this.cachedRows.length / this.pagination.rowsPerPage)
    },
  },

  methods: {
    i18n(key, args) {
      return i18n(key, args)
    },
    ...mapActions({
      collapseMenu: 'layout/collapseMenu',
      doFetch: 'home/list/doFetch',
      setOrderBy:'home/list/setOrderBy'
    }),
    openNav() {
      this.wid=100 ;
      this.hide = 'visible' ; 
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    animateValue(obj, start, end, duration) {
      if(obj){
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = this.numberWithCommas(Math.floor(progress * (end - start) + start));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
    }
  },
  async mounted(){
  },
  async created(){
    // console.log('created')
    this.setOrderBy({prop:'country',order:'ascending'})
    if(!localStorage.getItem('cache')){
      await firebase.firestore().enablePersistence().then(() =>{
        localStorage.setItem("cache", 'enabled');
      
      })
    }
    setTimeout(async ()=>{
 await firebase.firestore().collection('cases').onSnapshot({ includeMetadataChanges: true },async () => {
      const cases = await firebase.firestore().collection("cases").get({source: 'cache'})
      this.cachedData = cases.size 
      this.cachedRows = []
      cases.forEach(doc => {
        this.cachedRows.push(doc.data())
      })
      this.globalCached = this.cachedRows.find(I=>I.country.toLowerCase() === 'world wide') || {} //this.cachedRows[188]
      const confirmed = document.getElementById("confirmed");
      const recovered = document.getElementById("recovered");
      const deaths = document.getElementById("deaths");
      if(navigator.onLine) {
      this.animateValue(confirmed, 0, this.globalCached.totalConfirmed, 5000);
      this.animateValue(recovered, 0, this.globalCached.totalRecovered, 5000);
      this.animateValue(deaths, 0, this.globalCached.totalDeaths, 5000);
      }
      else{
        confirmed.innerHTML = this.numberWithCommas(this.globalCached.totalConfirmed)
        recovered.innerHTML = this.numberWithCommas(this.globalCached.totalRecovered)
        deaths.innerHTML = this.numberWithCommas(this.globalCached.totalDeaths)
      }
    })
    },3000)
   
  }
};
